import script from "./CommonComp.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommonComp.vue?vue&type=script&lang=ts&setup=true"

import "./CommonComp.vue?vue&type=style&index=0&id=3426a800&lang=scss&scoped=true"

import exportComponent from "/Users/ttheitao/Desktop/devApps/onetab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3426a800"]])

export default __exports__